import { FC } from "react";
import { NavLink } from "react-router";

import classNames from "classnames";
import { MENU, MENU_MAP, MENU_WITH_NEW_BADGE } from "./constants";
import Badge from "../Badge";

import styles from "./Menu.module.css";

const Menu: FC = () => {
  return (
    <nav className={styles["nav"]}>
      <header>
        {MENU.map((item) => (
          <NavLink
            key={item}
            className={({ isActive }) =>
              classNames(styles["nav__item"], isActive && styles["is-active"])
            }
            to={item}
          >
            {MENU_MAP[item]}
            {MENU_WITH_NEW_BADGE.includes(item) && (
              <Badge text="new" size="sm" className={styles["nav__badge"]} />
            )}
          </NavLink>
        ))}
      </header>
    </nav>
  );
};

export default Menu;
